import { Peer } from './Peer';
import WebSocketTransport from './transports/WebSocketTransport';

/**
 * Expose Peer class.
 *
 * @type {Class}
 */
export default { Peer, WebSocketTransport};
